import React, { useEffect, useState } from "react";
import api from "@/lib/api";
import useReveal from "@/hooks/useReveal";

export default function GlobalReach() {
  const ref = useReveal();
  const [items, setItems] = useState([]);
  useEffect(() => { api.get("/global-reach").then((r) => setItems(r.data)).catch(() => {}); }, []);
  return (
    <section id="reach" ref={ref} data-testid="reach" className="reveal section border-b border-[color:var(--line)] bg-[color:var(--paper-alt)]">
      <div className="container-x">
        <div className="grid lg:grid-cols-12 gap-10 items-center">
          <div className="lg:col-span-5">
            <div className="eyebrow">Global reach</div>
            <h2 className="font-display font-black text-4xl md:text-5xl mt-4 leading-[1.02]">
              Four hubs. One accountable delivery team.
            </h2>
            <p className="mt-6 text-neutral-700 leading-relaxed max-w-md">
              Follow-the-sun engineering across UAE, India, Germany and the UK — with one owner per project so nothing falls between the cracks.
            </p>
          </div>
          <div className="lg:col-span-7 grid grid-cols-2 md:grid-cols-2 border-l border-t border-[color:var(--line)]">
            {items.map((h) => (
              <div key={h.id} data-testid={`reach-${h.city.toLowerCase()}`} className="border-r border-b border-[color:var(--line)] p-6 bg-white hover:bg-neutral-50 transition-colors duration-200">
                <div className="text-2xl">{h.flag}</div>
                <h3 className="mt-3 font-display font-bold text-xl">{h.city}</h3>
                <div className="font-mono text-[10px] uppercase tracking-widest text-neutral-500 mt-1">{h.country}</div>
                {h.note && <p className="mt-3 text-sm text-neutral-600">{h.note}</p>}
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
